module.exports = __webpack_public_path__ + "img/15_pc.536b7232.gif";